module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-yen-28c3d34b0b4994e2cacf233bea895937.svg";